import ButtonComponent from "shared/pages/ButtonComponent";
import PaginationComponent from "shared/pages/PaginationComponent";
import SelectComponent from "shared/pages/SelectComponent";
import TextFieldComponent from "shared/pages/TextFieldComponent";

type ComponentRoute = {
  component?: any;
  path: string;
  name: string;
  isLabel?: boolean;
};

export const componentRoutes: Array<ComponentRoute> = [
  {
    path: "/component",
    name: "Component",
    isLabel: true,
  },
  {
    name: "Button",
    path: "/component/button",
    component: ButtonComponent,
  },
  {
    name: "TextField",
    path: "/component/text-field",
    component: TextFieldComponent,
  },
  {
    name: "Select",
    path: "/component/select",
    component: SelectComponent,
  },
  {
    name: "Pagination",
    path: "/component/pagination",
    component: PaginationComponent,
  },
];
